export default __webpack_public_path__ + "static/media/drink coffee1.b220d79f.png";